import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Previous = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Previous' {...props}>
    <polyline fill='none' stroke='#000' strokeWidth='2' points='7 2 17 12 7 22' transform='matrix(-1 0 0 1 24 0)' />
  </StyledIcon>
);
